import { render, staticRenderFns } from "./TableForm14.vue?vue&type=template&id=0046a345&scoped=true"
import script from "./TableForm14.vue?vue&type=script&lang=ts"
export * from "./TableForm14.vue?vue&type=script&lang=ts"
import style0 from "./TableForm14.vue?vue&type=style&index=0&id=0046a345&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046a345",
  null
  
)

export default component.exports